module.exports = __webpack_public_path__ + "img/garland_4.ce866c76.svg";